import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, SimpleChange } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { EntityService } from 'src/app/core/services/entity.service';
import { UserService } from 'src/app/core/services/user.service';
import { AppService } from 'src/app/core/services/app.service';
import { SettingsService } from 'src/app/core/services/settings.service';
import { Country, Timezone } from 'src/app/core/models/country.model';
import { App } from 'src/app/core/models/app.model';
import { Entity } from 'src/app/core/models/entity.model';
import { User } from 'src/app/core/models/user.model';
import * as utils from 'src/app/shared/helpers/utils';
import { Team } from 'src/app/core/models/team.model';
import { HorizonsTeam } from 'src/app/core/models/horizons-team.model';
import { map, Subscription } from 'rxjs';
import { Location } from '@angular/common';
import { DdbbUtils } from 'src/app/shared/helpers/utils';
import { ConfigService } from 'src/app/core/services/config.service';
import { LicenseService } from 'src/app/core/services/license.service';
import { Package } from 'src/app/core/models/package.model';
import { TeamScopeService } from 'src/app/core/services/team-scope.service';

@Component({
  selector: 'hbo-entity-actions',
  templateUrl: './entity-actions.component.html',
  styleUrls: ['./entity-actions.component.scss']
})
export class EntityActionsComponent implements OnInit, AfterViewInit {

  @Input() entity!: Entity;
  @Output() callback: EventEmitter<any> = new EventEmitter();

  @Input() selectorVisible!: boolean;
  persistParentEntity!: string | null;
  persistTeamId!: number | null;

  @Output() reload: EventEmitter<any> = new EventEmitter();

  action = 'create';

  user: User = utils.localStorageGetItem('user');

  utils = utils;

  reactiveToRole = 1;
  entityFormEntityTypeIdLstnr: Subscription = new Subscription;
  entityFormParentEntityIdLstnr: Subscription = new Subscription;

  parentEntityId: FormControl<string | null> = new FormControl(null, Validators.required);
  horizonsTeamId: FormControl<number | null> = new FormControl(0);
  teamId: FormControl<number | null> = new FormControl(0);
  head_office_herency_team!: string | null;

  entityForm = this.formBuilder.nonNullable.group({
    id: [''],
    internalCode: [''],
    entityTypeId: ['', Validators.required],
    parentEntityId: this.parentEntityId, // If entityTyptId === 1, it won't be necessary
    name: ['', Validators.required],
    identityCode: [''],
    horizonsTeamId: this.horizonsTeamId,
    teamId: this.teamId,
    email: [''],
    phone: [''],
    contact: [''],
    address: [''],
    country: [''],
    cityZipCode: [''],
    timezone: ['', Validators.required],
    isBase: [false]
  });

  countries: Country[] = [];
  timezones: Timezone[] = [];
  parentEntities: Entity[] = [];
  locatedBellow!: string;
  apps: App[] = [];

  selectedHorizonsTeam: number | null = null;
  selectedTeam: number | null = 0;

  teams: Team[] = [];
  partialTeams: Team[] = [];
  horizonsTeams: HorizonsTeam[] = [];


  constructor(
    public configSvc: ConfigService,
    private ddbbUtils: DdbbUtils,
    private formBuilder: FormBuilder,
    private router: Router,
    private entityService: EntityService,
    private userService: UserService,
    private location: Location,
    private settingsService: SettingsService,
    private appService: AppService,
    private licenseService: LicenseService,
    private teamScopeService: TeamScopeService
  ) {
    this.user.childEntities = this.configSvc.currentConfigValue.childEntities;
    if (this.action === 'create') this.selectorVisible = true;
  }

  ngOnInit() {
    if (!this.entity) {
      this.entity = { id: 0, parentEntityId: this.user.entity.id } as Entity;
    } else {
      this.action = 'edit';
      this.entityForm.get('internalCode')?.disable();
      this.entityForm.get('entityTypeId')?.disable();
      this.entity.entityTypeId === 1 ? this.entityForm.controls.parentEntityId.clearValidators() : null;
      this.getTimeZones();
    }

    //this.entityService.getOnlyParents().subscribe(entities => {
    //this.parentEntities = entities.data
    this.setParents();

    if (this.action === 'create') {
      let parentTimezone = this.parentEntities.find((entity: Entity) => entity.id === Number(this.entityForm.controls.parentEntityId.value))?.timezone;
      this.entityForm.get('timezone')?.setValue(String(parentTimezone));
    }
    //});
    /*this.entityService.getCountries().subscribe(countries => this.countries = this.csvToArray(countries));
    this.entityService.getTimezones().subscribe(timezones => {
      this.timezones = this.csvToArray(timezones);
      if (this.action === 'create' && this.entity.id === this.configSvc.currentConfigValue.userEntity!.id) {
        this.entityForm.controls.timezone.patchValue(this.configSvc.currentConfigValue.userEntity!.timezone);
      };
    });*/
    this.getCountries();
    this.getTimeZones();
    this.getApps();


    switch (this.user.roleId) {
      case 1:
        this.user.roleId == this.entity.entityTypeId || this.entity.entityTypeId == 2
          ? this.locatedBellow = this.user.entity.name
          : null;
        break;
      default:
        this.locatedBellow = this.entity.parentEntity ? this.entity.parentEntity!.name : '';
        break;
    }

    if (this.entity && this.entity.id === 0) {
      if (this.user.roleId == 1) this.entityForm.get('entityTypeId')?.setValue((this.user.roleId + 1).toString())
      else this.entityForm.get('entityTypeId')?.setValue((this.user.roleId + 2).toString())

      if (!this.horizonsTeams.length && this.user.roleId === 1) {
        this.setHorizonsTeams();
      }
    }

    this.entityFormEntityTypeIdLstnr = this.entityForm.controls.entityTypeId.valueChanges.subscribe(value => {
      this.entityForm.markAllAsTouched();
      this.reactiveToRole = Number(value);
      if (!this.teams.length) {
        this.setTeams();
      }
      if (!this.horizonsTeams.length && (this.user.roleId === 1 && this.entity.entityTypeId === 2) || (this.action === 'create' && this.entityForm.controls.entityTypeId.value === '2')) {
        this.setHorizonsTeams();
      }
      this.entityForm.controls.horizonsTeamId.patchValue(null);
      //this.entityForm.controls.teamId.patchValue(0)
      this.selectedTeam = 0;
      switch (this.user.roleId) {
        case 1:
          this.entityForm.controls.parentEntityId.patchValue(null)
          break;
        default:
          this.entityForm.controls.parentEntityId.patchValue(this.user.entityId.toString())
          break;
      }
      this.setParents();
    })
    this.entityFormParentEntityIdLstnr = this.entityForm.controls.parentEntityId.valueChanges.subscribe(value => {
      this.setTeam();
      let matchEntityByType = this.user.childEntities!.find((entity: Entity) => entity.id === Number(value))
      if (matchEntityByType && matchEntityByType.team && matchEntityByType!.entityTypeId == 3) {
        this.head_office_herency_team = matchEntityByType.team.name
        // Only set team from parent if user doesn't have a fixed team
        if (!this.user.teamId) {
          this.entityForm.controls.teamId.patchValue(matchEntityByType.team.id)
        }
      } else {
        this.head_office_herency_team = null
      }
      let parentTimezone = this.parentEntities.find((entity: Entity) => entity.id === Number(this.entityForm.controls.parentEntityId.value))?.timezone;
      if (this.action === 'create') {
        if (!parentTimezone) {
          this.entityForm.controls.timezone.patchValue(this.configSvc.currentConfigValue.userEntity!.timezone);
        } else {
          this.entityForm.controls.timezone.patchValue(String(parentTimezone));
        }
      }
      // Filter teams based on new parent entity
      this.filterTeamsForUser();
    })
  }

  getApps() {
    if (!this.configSvc.currentConfigValue!.apps)
      this.appService.getApps().subscribe(apps => {
        this.configSvc.setConfigParamsValue('apps', Object.values(apps))
        this.apps = Object.values(apps);
      });
    else this.apps = this.configSvc.currentConfigValue.apps;
  }


  getCountries = () => {
    if (!this.configSvc.currentConfigValue.countries) this.entityService.getCountries().subscribe(countries => {
      this.countries = this.csvToArray(countries);
      this.configSvc.setConfigParamsValue('countries', this.countries);
    })
    else this.countries = this.configSvc.currentConfigValue.countries;
  }

  getTimeZones = () => {
    if (!this.configSvc.currentConfigValue.timezones) {
      this.entityService.getTimezones().subscribe(timezones => {
        this.timezones = this.csvToArray(timezones);
        this.configSvc.setConfigParamsValue('timezones', this.timezones);
        /*if (this.action === 'create' && this.entity.id === this.configSvc.currentConfigValue.userEntity!.id) {
          this.entityForm.controls.timezone.patchValue(this.configSvc.currentConfigValue.userEntity!.timezone);
        };*/
      });
    } else {
      this.timezones = this.configSvc.currentConfigValue.timezones;
      /*if (this.action === 'create' && this.entity.id === this.configSvc.currentConfigValue.userEntity!.id) {
        this.entityForm.controls.timezone.patchValue(this.configSvc.currentConfigValue.userEntity!.timezone);
      };*/
    }
  }

  setTimeZone = () => {
    let parentTimezone = this.parentEntities.find((entity: Entity) => entity.id === Number(this.entityForm.controls.parentEntityId.value))?.timezone;
    if (!parentTimezone) {
      this.entityForm.controls.timezone.patchValue(this.configSvc.currentConfigValue.userEntity!.timezone);
    } else {
      this.entityForm.controls.timezone.patchValue(String(parentTimezone));
    }
  }

  setTeams = () => {
    if (!this.configSvc.currentConfigValue.teams) {
      this.userService.getTeams({ perPage: -1 }).pipe(map(res => {
        this.teams = res.data;
        this.configSvc.setConfigParamsValue('teams', res.data);
      })).subscribe(res => {
        this.filterTeamsForUser();
      });
      this.entityForm.get('teamId')?.setValidators(Validators.required);
      this.entityForm.get('teamId')?.updateValueAndValidity();
    }
    else {
      this.teams = this.configSvc.currentConfigValue.teams;
      this.filterTeamsForUser();
      this.entityForm.get('teamId')?.setValidators(Validators.required);
      this.entityForm.get('teamId')?.updateValueAndValidity();
    }
  }

  private filterTeamsForUser() {
    const parentEntityId = Number(this.entityForm.controls.parentEntityId.value);
    const myTeamIds = this.teamScopeService.myTeamIds();
    if (myTeamIds) {
      this.partialTeams = this.teams.filter(team =>
        myTeamIds.includes(team.id) && team.entity.id === parentEntityId
      );

      // With a single team the field stays fixed and disabled, as it always was.
      // With several the account has to pick one of its own
      const fixed = this.teamScopeService.fixedTeamId();
      if (fixed && this.partialTeams.length > 0) {
        this.entityForm.controls.teamId.patchValue(fixed);
        this.selectedTeam = fixed;
        this.entityForm.controls.teamId.disable();
      } else {
        this.entityForm.controls.teamId.enable();
      }
    } else {
      // If user has no team, show all teams for the selected parent entity (current behavior)
      this.partialTeams = this.teams.filter((team: Team) => team.entity.id === parentEntityId);
      // Enable the team field
      this.entityForm.controls.teamId.enable();
    }
  }

  setHorizonsTeams = () => {
    if (!this.configSvc.currentConfigValue.horizonsTeams) {
      this.userService.getHorizonsTeams({ perPage: -1 }).subscribe(horizonsTeams => {
        this.horizonsTeams = horizonsTeams.data;
        this.configSvc.setConfigParamsValue('horizonsTeams', horizonsTeams.data);
        this.setHorizonsTeamValidation();
      });
    }
    else {
      this.horizonsTeams = this.configSvc.currentConfigValue.horizonsTeams;
      this.setHorizonsTeamValidation();
    }
  }

  ngOnChanges(change: SimpleChange) {
    if (this.selectorVisible) (this.setForm(), this.setParents());
  }

  setForm = () => {
    console.log(this.entity);
    this.entityForm.setValue({
      id: String(this.entity.id),
      internalCode: String(this.entity.internalCode ?? ''),
      entityTypeId: String(this.entity.entityTypeId ?? ''),
      parentEntityId: String(this.entity.parentEntityId ?? ''),
      name: this.entity.name ?? '',
      identityCode: String(this.entity.identityCode ?? ''),
      horizonsTeamId: this.entity.horizonsTeamId,
      teamId: this.entity.teamId,
      email: this.entity.email,
      phone: this.entity.phone ?? '',
      contact: this.entity.contact ?? '',
      address: this.entity.address ?? '',
      country: this.entity.country ?? '',
      cityZipCode: String(this.entity.cityZipCode ?? ''),
      timezone: this.entity.timezone,
      isBase: this.entity.isBase ?? false
    });
    this.persistParentEntity = this.entityForm.controls.parentEntityId.value;
    this.persistTeamId = this.entity.teamId;
    this.setTeam();
    this.setHorizonsTeams();
  }

  setHorizonsTeamValidation = () => {
    if (this.entityForm.get('entityTypeId')!.value === '2') {
      this.entityForm.get('horizonsTeamId')?.setValidators(Validators.required);
      this.entityForm.get('horizonsTeamId')?.updateValueAndValidity();
    } else {
      this.entityForm.get('horizonsTeamId')?.removeValidators(Validators.required);
      this.entityForm.get('horizonsTeamId')?.updateValueAndValidity();
    }
  }

  setTeam = () => {
    this.filterTeamsForUser();
    // Only proceed with team matching if user doesn't have a fixed team
    if (!this.user.teamId) {
      const teamMatch = this.partialTeams.find((team: Team) => team.id === this.persistTeamId);
      if (teamMatch) {
        this.entityForm.controls.teamId.patchValue(teamMatch.id);
        this.selectedTeam = teamMatch.id;
      } else {
        this.entityForm.controls.teamId.patchValue(0);
        this.selectedTeam = 0;
      }
    }
    // If user has a team, filterTeamsForUser() already set it
  }

  ngOndestroy() {
    this.entityFormEntityTypeIdLstnr.unsubscribe();
    this.entityFormParentEntityIdLstnr.unsubscribe();
  }

  ngAfterViewInit() {
    if (this.entity && this.entity.id !== 0) {
      this.entityForm.patchValue({
        id: this.entity.id?.toString(),
        internalCode: this.entity.internalCode?.toString(),
        entityTypeId: this.entity.entityTypeId?.toString(),
        parentEntityId: this.entity.parentEntityId?.toString(),
        name: this.entity.name,
        identityCode: this.entity.identityCode?.toString(),
        horizonsTeamId: this.entity.horizonsTeam?.id ?? 0,
        teamId: this.entity.team?.id ?? 0,
        email: this.entity.email,
        phone: this.entity.phone,
        contact: this.entity.contact,
        address: this.entity.address,
        country: this.entity.country,
        cityZipCode: this.entity.cityZipCode?.toString(),
        timezone: this.entity.timezone,
        isBase: this.entity.isBase ?? false
      });
      this.selectedTeam = this.entity.team?.id! | 0;
      this.selectedHorizonsTeam = this.entity.horizonsTeam?.id! | 0;
      // If user has a team, disable team field for editing
      if (this.teamScopeService.fixedTeamId() && this.action === 'edit') {
        this.entityForm.controls.teamId.disable();
      }
    } else {
      this.entityForm.controls.parentEntityId.patchValue(this.entity.parentEntityId?.toString());
      if (this.user.roleId != 1) this.entityForm.controls.entityTypeId.patchValue('4');
      // For new entities, automatically set user's team if they have one
      const fixed = this.teamScopeService.fixedTeamId();
      if (fixed) {
        this.entityForm.controls.teamId.patchValue(fixed);
        this.selectedTeam = fixed;
        this.entityForm.controls.teamId.disable();
      }
    }
    const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
    tooltipTriggerList.forEach(tooltipTrigger => new window['bootstrap' as keyof typeof window].Tooltip(tooltipTrigger));

  }

  csvToArray(csvString: string) {
    const lines = csvString.split('\n');
    const headerValues = lines[0].split(',');
    const dataValues = lines.splice(1).map(dataLine => dataLine.split(','));
    dataValues.pop();
    return dataValues.map(rowValues => {
      const row: any = {};
      headerValues.forEach((headerValue, index) => {
        row[headerValue] = (index < rowValues.length) ? rowValues[index] : null;
      });
      return row;
    });
  }

  save() {
    this.entityForm.markAllAsTouched();
    // Enable teamId temporarily to include it in form value if it was disabled
    const teamIdWasDisabled = this.entityForm.controls.teamId.disabled;
    if (teamIdWasDisabled) {
      this.entityForm.controls.teamId.enable(); 
    }

    if (this.entityForm.valid) {
      if (this.action === 'create') {
        this.entityService.insert({ ...this.entityForm.value } as unknown as Entity).subscribe(res => {
          //refresh user childs
          this.getEntitiesByPages(this.user.entityId, 1, 3000);
        });
      } else if (this.action === 'edit') { 
        // Check for team change before updating (only if user can change teams)
        if (this.entity.entityTypeId === 3 && !this.user.teamId &&
            this.persistTeamId !== this.entityForm.controls.teamId.value) {
          // Update all children entities to the new team
          this.updateChildrenTeam(this.entity.id, this.entityForm.controls.teamId.value!);

          // Update the persistent team ID to the new value
          this.persistTeamId = this.entityForm.controls.teamId.value;
        }

        this.entityService.getEntityApps(Number(this.entityForm.value.id)).subscribe(res => {
          //this.persistParentEntity = this.entityForm.controls.parentEntityId.value;
          let appGroup: String[] = [];
          res.appsIds.map((appId: number) => {
            let group = this.apps.find(obj => obj.id === appId)?.group;
            if (group != undefined && !appGroup.includes(group)) {
              appGroup.push(group)
            }
          })
          // This does not work because the settings service requires hyerarchy
          // appGroup.map((group) => {
          //   if (group == 'Mimesys') {
          //     this.settingsService.updateMimesys(Number(this.entityForm.value.id), null, this.entity.entityTypeId, { "settings": { "timezone": this.entityForm.value.timezone } }).subscribe(res => {
          //       console.log('update mimesys response', res);
          //     })
          //   }
          //   if (group == 'Invision'){
          //     // Depict has no timezone. If we have any invision app.
          //     this.settingsService.updateInvision(Number(this.entityForm.value.id), null, this.entity.entityTypeId, { "settings": { "timezone": this.entityForm.value.timezone } }).subscribe(res => {
          //       console.log('update invision response', res);
          //     })
          //   }
          // })
        })
        const propsPossibleEmpty = ['identityCode', 'email', 'phone', 'contact', 'address', 'cityZipCode','teamId'];
        this.entityService.update({ ...this.entityForm.value } as unknown as Entity, propsPossibleEmpty).subscribe(res => {
          this.callback.emit({ action: 'updated', result: res });
          this.deepMerge(this.configSvc.currentConfigValue.childEntities!.find((entity: Entity) => entity.id === res.id), res);
          this.configSvc.setConfigParamsValue('childEntities', this.configSvc.currentConfigValue.childEntities);
          //this.setParents();
        });
      }
    }
    // Re-disable teamId if it was disabled before
    if (teamIdWasDisabled) {
      this.entityForm.controls.teamId.disable();
    }
  }

  // Add this new method to update children teams
  private updateChildrenTeam(parentEntityId: number, newTeamId: number) {
    // Filter children entities from the existing data
    const children = this.configSvc.currentConfigValue.childEntities?.filter(
      (entity: Entity) => entity.parentEntityId === parentEntityId
    );

    if (children && children.length > 0) {
      console.log(`Found ${children.length} children for entity ${parentEntityId}`);

      // Filter children that actually need updating (different team)
      const childrenToUpdate = children.filter(child => child.teamId !== newTeamId);

      if (childrenToUpdate.length === 0) { // No children need team updates
        return;
      }

      // Update each child entity's team
      childrenToUpdate.forEach(child => {
        console.log(`Updating child entity ${child.id} from team ${child.teamId} to team ${newTeamId}`);

        const updatedChild = { ...child, teamId: newTeamId };
        this.entityService.update(updatedChild, ['teamId']).subscribe({
          next: (updatedResult) => {
            console.log(`Successfully updated child entity ${child.id}`);

            // Update the local configuration immediately
            const localChild = this.configSvc.currentConfigValue.childEntities?.find(e => e.id === child.id);
            if (localChild) {
              localChild.teamId = newTeamId;
              // Update the team object if it exists
              const newTeam = this.teams.find(t => t.id === newTeamId);
              if (newTeam) {
                localChild.team = newTeam;
              }
            }
          },
          error: (error) => {
            console.error(`Failed to update child entity ${child.id}:`, error);
          }
        });
      });

      // Update the local configuration after processing
      setTimeout(() => {
        this.configSvc.setConfigParamsValue('childEntities', this.configSvc.currentConfigValue.childEntities);
      }, 500);
    } else {
      console.log('No children found for entity', parentEntityId);
    }
  }

  setParents() {
    switch (this.action) {
      case 'edit':
        switch (this.user.roleId) {
          case 1:
            this.parentEntities = this.configSvc.currentConfigValue.childEntities!.filter((entity: Entity) => entity.entityTypeId !== 4);
            break;
          default:
            switch (this.entityForm.controls.entityTypeId.value) {
              case '3':
                if (this.user.roleId === 3) {
                  this.entityForm.controls.parentEntityId.patchValue(this.user.entityId.toString());
                  let matchEntityByType = this.configSvc.currentConfigValue.userEntity;
                  if (matchEntityByType) {
                    this.head_office_herency_team = matchEntityByType.team!.name
                    this.entityForm.controls.teamId.patchValue(matchEntityByType.team!.id);
                  } else {
                    this.head_office_herency_team = null
                  };
                }
                break;
              case '4':
                switch (this.user.roleId) {
                  case 2:
                    this.entityForm.controls.parentEntityId.patchValue(this.entity.parentEntityId.toString());
                    break;
                  case 3:
                    this.entityForm.controls.parentEntityId.patchValue(this.user.entityId.toString());
                    let matchEntityByType = this.configSvc.currentConfigValue.userEntity;
                    if (matchEntityByType) {
                      this.head_office_herency_team = matchEntityByType.team!.name
                      this.entityForm.controls.teamId.patchValue(matchEntityByType.team!.id);
                    } else {
                      this.head_office_herency_team = null
                    };
                    break;
                  default:
                    //this.entityForm.controls.parentEntityId.patchValue('1');
                    this.parentEntities = this.configSvc.currentConfigValue.childEntities!.filter((entity: Entity) => entity.entityTypeId !== 4);
                    break;
                }
                // if (this.user.roleId !== 1) this.setDynamicUserTimeZone();
                break;
              default:
                break;
            }
            this.parentEntities = this.configSvc.currentConfigValue.childEntities!.filter((entity: Entity) => entity.entityTypeId !== 4);
            break;
        }
        break;
      case 'create':
        let parentEntities = [];
        switch (this.entityForm.controls.entityTypeId.value) {
          case '2':
            this.parentEntities = [];
            //this.entityForm.controls.parentEntityId.patchValue('1');
            // this.setDynamicUserTimeZone();
            break;
          case '3':
            this.selectorVisible = false;
            const propsToRemove = ['children', 'parentEntity', 'parentEntityId'];
            parentEntities = this.configSvc.currentConfigValue.childEntities!.filter((entity: Entity) => entity.entityTypeId === 2);
            if (this.user.roleId === 2) this.entityForm.controls.parentEntityId.patchValue(this.user.entityId.toString());
            /*else this.entityForm.controls.parentEntityId.patchValue('1');*/
            this.parentEntities = parentEntities.map(obj => {
              const newObj: any = { ...obj };
              propsToRemove.forEach((prop: any) => delete newObj[prop]);
              return newObj;
            });
            // if (this.user.roleId !== 1) this.setDynamicUserTimeZone();
            this.selectorVisible = true;
            break;
          case '4':
            if (this.user.roleId === 3) {
              this.entityForm.controls.parentEntityId.patchValue(this.user.entityId.toString());
              let matchEntityByType = this.configSvc.currentConfigValue.userEntity;
              if (matchEntityByType) {
                this.head_office_herency_team = matchEntityByType.team!.name
                this.entityForm.controls.teamId.patchValue(matchEntityByType.team!.id);
              } else {
                this.head_office_herency_team = null
              };
            } else {
              //this.entityForm.controls.parentEntityId.patchValue('1');
              this.parentEntities = this.configSvc.currentConfigValue.childEntities!.filter((entity: Entity) => entity.entityTypeId !== 4);
            }

            // if (this.user.roleId !== 1) this.setDynamicUserTimeZone();
            break;
          default:
            break;
        }
        this.setHorizonsTeamValidation();
        break;
      default:
        break;
    }

  }

  setDynamicUserTimeZone = () => {
    let parentTimezone = this.configSvc.currentConfigValue.userEntity!.timezone;
    this.entityForm.get('timezone')?.setValue(String(parentTimezone));
  }

  deepMerge = (target: any, source: any) => {
    for (const key in source) {
      if (
        source[key] &&
        typeof source[key] === 'object' &&
        !Array.isArray(source[key])
      ) {
        if (!target[key] || typeof target[key] !== 'object') {
          target[key] = {};
        }
        this.deepMerge(target[key], source[key]);
      } else {
        target[key] = source[key];
      }
    }
    return target;
  }

  delete() {
    this.entityService.destroy(this.entity.id).subscribe(res => {
      this.getEntitiesByPages(this.user.entityId, 1, 10000, 2);
    });
  }

  cancel() {
    if (this.action === 'create') {
      this.location.back();
    } else {
      //this.reload.emit();
      this.setForm();
    }
  }

  getEntitiesByPages = (_entityId: number, _page: number, _perPage: number, _action?: number) => {
    this.ddbbUtils.getEntityChilds(_entityId, _page, _perPage).then(result => {
      if (_page === 1) {
        this.configSvc.setConfigParamsValue('childEntities', result.data);
      } else {
        let concatanate = this.configSvc.currentConfigValue.childEntities!.concat(result.data)
        this.configSvc.setConfigParamsValue('childEntities', concatanate);
      }
      if (_page * _perPage >= result.total) {
        switch (_action) {
          case 2:
            this.reload.emit();
            break;
          default:
            this.router.navigate(['entities']);
            break
        }
      } else {
        this.getEntitiesByPages(_entityId, _page + 1, _perPage);
      }
    })
  }

  onChange(id: number, _type?: string) {
    switch (_type) {
      case 'entity':
        this.entityForm.controls.parentEntityId.patchValue(id.toString());
        //this.persistParentEntity = id.toString();
        /*if (this.user.entityId === id) {
          let parentTimezone = this.configSvc.currentConfigValue.userEntity!.timezone;
          this.entityForm.get('timezone')?.setValue(String(parentTimezone));
        };*/
        this.setTimeZone();
        break;
      default:
        break;
    }
  }

}
